<template>
    <div class="landing">
        <scroll-parallax :speed="0.1">
            <BackgroundImage image="landing" height="100" :useParallax="true" />
            <div class="landing__bottom"></div>
        </scroll-parallax>
        <Arrows v-if="showArrows" />
        <div class="container">
            <div class="landing__hero">
                <scroll-parallax :speed="0.15">
                    <h1 class="landing__hero-header">
                        Thinking <span>Retail</span><br />and
                        <span>Technology</span>
                    </h1>

                    <p class="landing__hero-copy">
                        Vi utvecklar mjukvaror och bistår med know-how som
                        förenklar vardagen på butiksgolvet, effektiviserar
                        butiksprocesser och bidrar till ökad lönsamhet för
                        handeln oavsett säljkanal
                    </p>
                    <div class="landing__hero-buttons">
                        <Button variant="primary" to="services">
                            <template v-slot:text>
                                Läs mer om
                                <span style="font-weight: 700"
                                    >våra tjänster</span
                                >
                            </template>
                            <template v-slot:icon>
                                <img
                                    src="../assets/icons/landing-btn-services-icon.svg"
                                />
                            </template>
                        </Button>
                        <Button variant="ghost" to="contact">
                            <template v-slot:text>
                                Här kan du
                                <span style="font-weight: 700"
                                    >kontakta oss</span
                                >
                            </template>
                            <template v-slot:icon>
                                <img
                                    src="../assets/icons/landing-btn-contact-icon.svg"
                                />
                            </template>
                        </Button>
                    </div>
                </scroll-parallax>
            </div>
            <div class="landing__facebook" id="landing-facebook">
                <div class="landing__facebook--heading">
                    <h2 class="landing__facebook--heading-text">
                        Aktuellt på <span>Retail Only</span>
                    </h2>
                    <Button
                        variant="facebook"
                        href="https://www.facebook.com/Retail-Only-465857273847638/"
                    >
                        <template v-slot:text>
                            Följ oss på Facebook
                            <span style="font-weight: 700"
                                >för uppdateringar</span
                            >
                        </template>
                        <template v-slot:icon>
                            <img
                                src="../assets/icons/landing-btn-facebook-icon.svg"
                            />
                        </template>
                    </Button>
                </div>
                <FacebookPosts />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'

import Arrows from '@/components/Start/Arrows.vue'
import FacebookPosts from '@/components/Start/FacebookPosts.vue'
import Button from '@/components/Common/Button.vue'
import BackgroundImage from '@/components/Common/BackgroundImage.vue'

export default defineComponent({
    name: 'Start',
    components: {
        ScrollParallax,
        Arrows,
        Button,
        BackgroundImage,
        FacebookPosts,
    },
    setup() {
        const showArrows = ref(true)

        window.addEventListener('scroll', () => {
            const height = window.innerHeight
            const offsetOfHeight = window.pageYOffset / height

            if (offsetOfHeight > 0.4) {
                showArrows.value = false
            } else {
                showArrows.value = true
            }
        })

        return { showArrows }
    },
})
</script>

<style lang="scss" scoped>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/config';

.landing {
    position: relative;

    &__hero {
        height: 100vh;
        width: 100%;
        position: relative;
        z-index: 10;
        padding-top: 25vh;

        @include mQ(550px) {
            padding-top: 20vh;
        }

        &-header {
            text-align: center;
            color: $ro-grey;
            line-height: 0.9;

            & span {
                color: $accent-color;
            }
        }

        &-copy {
            color: $font-color-main-grey;
            padding: 4rem 0;
            text-align: center;
            font-size: 1.3rem;
            width: 60%;
            margin: 0 auto;

            @include mQ(700px) {
                font-size: 1rem;
                padding: 2rem 0;
                width: 100%;
                margin-bottom: 1rem;
                line-height: 1.6;
            }
        }

        &-buttons {
            width: 100%;
            margin: 0 auto;
            display: flex;
            justify-content: center;

            @include mQ(700px) {
                flex-direction: column;
            }

            & a:first-of-type {
                margin-right: 1rem;

                @include mQ(700px) {
                    margin-right: 0;
                    margin-bottom: 1rem;
                }
            }
        }
    }

    &__bottom {
        position: absolute;
        height: 12vh;
        top: 93vh;
        left: -50%;
        width: 200%;
        z-index: 5;
        transform: rotate(-3deg);
        background-color: #fff;
    }

    &__facebook {
        position: relative;
        padding: 10rem 0rem 6rem 0;
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        z-index: 50;
        width: 85%;

        @include mQ(900px) {
            width: 100%;
        }

        @include mQ(700px) {
            width: 100%;
            padding: 8rem 0 2rem 0;
        }

        &--heading {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @include mQ(1024px) {
                flex-direction: column;
                justify-content: center;
            }

            &-text {
                font-size: 2.5rem;

                @include mQ(1024px) {
                    margin-bottom: 1rem;
                }

                @include mQ(700px) {
                    font-size: 1.5rem;
                    text-align: center;
                }

                span {
                    font-weight: 900;
                }
            }
        }
    }
}
</style>
